import { render, staticRenderFns } from "./Lckv-Footer.vue?vue&type=template&id=70969494&scoped=true&"
import script from "./Lckv-Footer.vue?vue&type=script&lang=js&"
export * from "./Lckv-Footer.vue?vue&type=script&lang=js&"
import style0 from "./Lckv-Footer.vue?vue&type=style&index=0&id=70969494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70969494",
  null
  
)

export default component.exports